/**
 * @description 评论保存接口
 * @author duanjun
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { CommentParentType, CommentSubjectType } from '@umu/umu-types';

interface IInput {
    parent_type: CommentParentType;
    parent_id: number;
    subject_type?: CommentSubjectType;
    subject_id?: number;
}

interface IOutput {
    normal_count: number; // 评论总数，只包含到subject id级别（如果有这个参数）
    shield_count: number; // 评论屏蔽总数
    audit_count: number; // 待审核评论总数
    total_normal_count: number; // 评论总数，包含到parent id级别
    comment_like_count: number; // 评论点赞数
    participator_count: number; // subject参数人数
    session_participator_count: number; // 小节参数人数
    weike_like_count: number; // 小节点赞数
    weike_star_average: number; // 小节5星评价平均分
    weike_star_count: number; // 小节5星评价总数
}

export type IResponseData = IResponse<IOutput>;

export const getCommentBannerInfo = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.GET_COMMENT_BANNER_INFO, data).then((res: IResponseData) => {
        return res;
    });
};
